<template>
	<c-dialog ref="dialog" mask-close mode="slide" width="80vw" :button="false" enable-flex>
		<module>
			<!-- 产品信息头部 -->
			<div class="product-header">
				<h3>{{productData.product_name || '-'}}</h3>
				<p v-if="productData.produce_imei">IMEI：{{productData.produce_imei}}</p>
			</div>

			<!-- 维修记录 -->
			<c-form vertical unit-width="100%">
				<c-title>维修记录</c-title>
				<c-form-item :label="false">
					<m-operate border>
						<c-button v-if="canEditRepairRecord && topButtons.add_repair_record && topButtons.add_repair_record.visible" prepend-icon="tf-add" color="default" @click="openAddRepair">新建维修记录</c-button>
						<span v-else-if="canEditRepairRecord && operateReason" class="toolbar-tip">{{operateReason}}</span>
					</m-operate>
					<c-table ref="repairList" :data="repairRecordList" border>
						<c-table-column label="维修人" width="100">
							<template #default="{data}">{{data.create_user_name || '-'}}</template>
						</c-table-column>
						<c-table-column label="维修项目" width="150">
							<template #default="{data}">{{data.repair_item_name || '-'}}</template>
						</c-table-column>
						<c-table-column label="维修金额" width="100">
							<template #default="{data}">{{data.repair_amount ? '￥' + data.repair_amount : '-'}}</template>
						</c-table-column>
						<c-table-column label="维修时间" width="130">
							<template #default="{data}">{{data.complete_date || '-'}}</template>
						</c-table-column>
						<c-table-column label="备注" width="160">
							<template #default="{data}">{{data.remark || '-'}}</template>
						</c-table-column>
						<c-table-column label="操作" width="120" type="button" button-limit="6">
							<template #default="{data}">
								<c-table-button v-if="data.buttons?.view_repair_record?.visible" icon="tf-detail" @click="recordDetailHandle(data)">查看</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</c-form-item>

				<!-- 送修记录 -->
				<c-title>送修记录</c-title>
				<c-form-item :label="false">
					<m-operate border>
						<c-button v-if="canEditDelivery && topButtons.add_delivery && topButtons.add_delivery.visible" prepend-icon="tf-add" color="default" @click="openAddDelivery">新建送修记录</c-button>
					</m-operate>
					<c-table ref="deliveryList" :data="deliveryRecordList" border>
						<c-table-column label="送修人" width="70">
							<template #default="{data}">{{data.sender_user_name || '-'}}</template>
						</c-table-column>
						<c-table-column label="维修单位" width="90">
							<template #default="{data}">{{data.repair_unit || '-'}}</template>
						</c-table-column>
						<c-table-column label="维修项" width="100">
							<template #default="{data}">{{data.repair_item_name || '-'}}</template>
						</c-table-column>
						<c-table-column label="维修金额" width="80">
							<template #default="{data}">{{data.repair_amount ? '￥' + data.repair_amount : '-'}}</template>
						</c-table-column>
						<c-table-column label="送修时间" width="130">
							<template #default="{data}">{{data.delivery_date || '-'}}</template>
						</c-table-column>
						<c-table-column label="备注" width="120">
							<template #default="{data}">{{data.remark || '-'}}</template>
						</c-table-column>
						<c-table-column label="状态" width="100">
							<template #default="{data}">
								<c-state dict="deliveryRepairStateDic" :value="data.delivery_state" ></c-state>
							</template>
						</c-table-column>
						<c-table-column label="送修完成时间" width="130">
							<template #default="{data}">{{data.complete_date || '-'}}</template>
						</c-table-column>
						<c-table-column label="送修时长" width="70">
							<template #default="{data}">{{getDeliveryDuration(data)}}</template>
						</c-table-column>
						<c-table-column label="操作" width="120" type="button" button-limit="6">
							<template #default="{data}">
								<c-table-button v-if="canFinishDelivery && data.buttons?.complete_delivery?.visible" icon="tf-finish" @click="completeDelivery(data)">送修完成</c-table-button>
								<c-table-button v-if="canEditDelivery && data.buttons?.delete_delivery?.visible" icon="tf-trash" color="red" @click="deleteDeliveryRecord(data)">删除</c-table-button>
								<c-table-button v-if="data.buttons?.view_delivery?.visible" icon="tf-detail" @click="deliveryDetailHandle(data)">查看</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</c-form-item>
			</c-form>
		</module>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
	name: 'repairRecordDialog',

	data() {
		return {
			productData: {
                product_name: '',
                produce_imei: '',
                produce_unique_code_id: '',
                produce_unique_code: '',
            },
			repairRecordList: [],
			deliveryRecordList: [],
			/**弹框顶部新增按钮可见性（服务端 operateAuth 下发 buttons）：门店版无接驳记录*/
			topButtons: {},
			/**不可操作原因（可操作时为空），用于就地解释按钮为何不显示，避免用户反复点行*/
			operateReason: '',
			deliveryStateOptions: [
				{name: '送修中', value: 1, color: 'blue'},
				{name: '送修完成', value: 2, color: 'green'}
			]
		}
	},
    computed: {
        ...mapState(['deliveryRepairStateDic', 'repairRecordStateDic']),

        /**
         * 维修记录写操作点位：维修列表已对门店版开放（见方案文档 ADR-03），
         * 本页只从维修列表进入，点位单认 b_repair_list_*（商品列表从未挂过维修入口）
         */
        canEditRepairRecord() {
            return this.auth('b_repair_list_repair');
        },

        /*********送修记录新增/删除点位**********/
        canEditDelivery() {
            return this.auth('b_repair_list_send_repair');
        },

        /*********送修完成点位**********/
        canFinishDelivery() {
            return this.auth('b_repair_list_send_repair_finish');
        }
    },

	methods: {
		/*********获取产品信息文字**********/
		getProductText(data) {
			var parts = [];
			if (data.brand_name) parts.push(data.brand_name);
			if (data.model_name) parts.push(data.model_name);
			if (data.color_name) parts.push(data.color_name);
			if (data.memory_name) parts.push(data.memory_name);
			return parts.join(' ') || '-';
		},

		/*********打开弹框**********/
		open(data) {
			this.productData = data || {};
            this.productData.product_name = this.getProductText(data);
			this.repairRecordList = [];
			this.deliveryRecordList = [];
			/**每次打开先回到不可操作，权限结论回来前不显示操作按钮（查询异常时保持隐藏，不误放开）*/
			this.topButtons = {};
			this.operateReason = '';
			this.$refs.dialog.open({title: '维修记录 – ' + (data.produce_unique_code || '')});
			this.loadData();
			this.loadOperateAuth();
		},

		/*********加载可操作权限**********/
		loadOperateAuth() {
			var productCodeId = this.productData.produce_unique_code_id;
			if (!productCodeId) return;
			this.request({
				url: '/repair/record/operateAuth',
				data: {produce_unique_code_id: productCodeId},
				success: (data) => {
					var result = data || {};
					this.topButtons = result.buttons || {};
					var add = this.topButtons.add_repair_record;
					this.operateReason = (add && add.visible === false) ? (add.reason || '') : '';
				}
			});
		},

		/*********加载数据**********/
		loadData() {
			var productCodeId = this.productData.produce_unique_code_id;
			if (!productCodeId) return;
			this.loadRepairRecords(productCodeId);
			this.loadDeliveryRecords(productCodeId);
		},

		/*********加载维修记录**********/
		loadRepairRecords(productCodeId) {
			this.request({
				url: '/repair/record/listByProduct',
				data: {produce_unique_code_id: productCodeId},
				success: (data) => {
					var list = data;
					if (data && data.obj) list = data.obj;
					this.repairRecordList = list || [];
				}
			});
		},

		/*********加载送修记录**********/
		loadDeliveryRecords(productCodeId) {
			this.request({
				url: '/repair/delivery/list',
				data: {produce_unique_code_id: productCodeId, page_size: 100},
				success: (data) => {
					// 处理分页响应：{obj: [...], total: N} 或直接返回数组
					var list = data;
					if (data && data.obj) {
						list = data.obj;
					} else if (data && data.list) {
						list = data.list;
					}
					this.deliveryRecordList = list || [];
				}
			});
		},

		/*********计算送修时长**********/
		getDeliveryDuration(data) {
			if (!data.delivery_date) return '-';
			var end = data.complete_date ? new Date(data.complete_date) : new Date();
			var start = new Date(data.delivery_date);
			var days = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
			return days + '天';
		},

		/*********打开新建维修记录弹框**********/
		openAddRepair() {
			this.globalDialog('repairAddDialog', {
                data: this.productData
            }, () => {
				this.loadRepairRecords(this.productData.produce_unique_code_id);
				this.$emit('resolve');
			});
		},

		/*********打开新建送修记录弹框**********/
		openAddDelivery() {
			this.globalDialog('repairDeliveryDialog', {
				props: {
					productData: this.productData
				}
			}, () => {
				this.loadDeliveryRecords(this.productData.produce_unique_code_id);
				//通知打开本弹窗的外层列表刷新
				this.$emit('resolve');
			});
		},

		/*********维修记录详情**********/
		/**维修完成后本条记录冻结、编辑入口隐藏，看分项金额只能走详情弹框；只读展示不再叠加操作权限*/
		recordDetailHandle(data) {
			this.globalDialog('repairRecordDetailDialog', {
				data
			});
		},

		/*********删除送修记录**********/
		deleteDeliveryRecord(data) {
			this.$confirm({
				message: '确认删除该送修记录吗？',
				cancelButton: true,
				resolve: () => {
					// 加载送修记录详情，然后提交空列表以删除所有明细
					this.request({
						url: '/repair/delivery/delete',
						data: {id: data.id},
						loading: true,
						success: () => {
                            this.$message({message: '删除成功', type: 'success'});
                            this.loadDeliveryRecords(this.productData.produce_unique_code_id);
                            //通知打开本弹窗的外层列表刷新
                            this.$emit('resolve');
						}
					});
				}
			});
		},

		/*********送修记录详情**********/
		/**送修完成后记录冻结，列表里的维修项是拼接文本，分项金额从这里看*/
		deliveryDetailHandle(data) {
			this.globalDialog('repairDeliveryDetailDialog', {
				data
			});
		},

		/*********送修完成**********/
		completeDelivery(data) {
			this.globalDialog('repairCompleteDialog', {
				data
			}, () => {
				this.loadDeliveryRecords(this.productData.produce_unique_code_id);
				//通知打开本弹窗的外层列表刷新
				this.$emit('resolve');
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
.product-header
	text-align center
	padding 0 0 12px
	background-color #F0F3FF
	h3
		font-size 18px
		font-weight 600
		color #3D5EFF
		line-height 46px
	p
		margin 0
		font-size 13px
		color #999

	.m-dialog-body {
		padding: 0 20px;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
	}
.section-toolbar
	margin-bottom 12px
	&.flex-center-cross
		gap 12px

.toolbar-tip
	font-size 12px
	color #999
</style>
